export default "/_next/static/sounds/rory_isnt_funny_scott-68d9d13103aa4c68b44937b39163604a.mp3";